// Global cleanup module for handling page unload cleanup functions
// Uses pagehide event for reliable cleanup on page refresh/close

type CleanupFunction = () => void;

const cleanupRegistry = new Map<string, CleanupFunction>();

const executeCleanup = () => {
  cleanupRegistry.forEach((cleanupFn, key) => {
    try {
      cleanupFn();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(`Cleanup function '${key}' failed:`, error);
    }
  });
};

// Register the pagehide listener when module loads
window.addEventListener('pagehide', executeCleanup);

/**
 * Registers a cleanup function to be executed when the page is being unloaded.
 * Uses pagehide event which is more reliable than beforeunload.
 *
 * @param key - Unique identifier for the cleanup function
 * @param cleanupFn - Function to execute on page unload
 */
export const registerCleanup = (key: string, cleanupFn: CleanupFunction) => {
  cleanupRegistry.set(key, cleanupFn);
};

/**
 * Removes a cleanup function from the registry.
 * Note: Generally not needed as cleanup functions should persist for the entire session.
 *
 * @param key - Unique identifier of the cleanup function to remove
 */
export const unregisterCleanup = (key: string) => {
  cleanupRegistry.delete(key);
};
